export enum CustomerStatusEnumerator {
    ACTIVE = 'active',
    BLACKLISTED = 'blacklisted',
    DEFAULT = 'default',
    OVERDUE = 'overdue',
    COMPLETED = 'completed',
    Pending = 'pending',
}
export enum CustomerTypeEnum {
    LOAN = 'loan',
    CASH = 'cash',
}
